"use strict";
/*
   Copyright Avero, LLC
   Licensed under the Apache License, Version 2.0 (the "License");
   you may not use this file except in compliance with the License.
   You may obtain a copy of the License at
       http://www.apache.org/licenses/LICENSE-2.0
   Unless required by applicable law or agreed to in writing, software
   distributed under the License is distributed on an "AS IS" BASIS,
   WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
   See the License for the specific language governing permissions and
   limitations under the License.
 */
Object.defineProperty(exports, "__esModule", { value: true });
var guards_1 = require("./interfaces/guards");
var parse_1 = require("./parse");
exports.route = function () {
    var pathParts = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        pathParts[_i] = arguments[_i];
    }
    // ts was yelling about this array as a never[]?
    var emptyArr = [];
    return _routeCreator(pathParts, emptyArr);
};
function _routeCreator(pathParts, queryParams) {
    return {
        template: function () {
            return ('/' + pathParts.map(function (part) { return (guards_1.isParam(part) ? ":" + part.param : part); }).join('/'));
        },
        create: function (params) {
            var baseUrl = '/' +
                pathParts
                    .map(function (part) {
                    if (guards_1.isParam(part)) {
                        var param = part.param;
                        return params[param];
                    }
                    return part;
                })
                    .join('/');
            if (!params.query || Object.keys(params.query).length === 0) {
                return baseUrl;
            }
            var queryParams = Object.entries(params.query) || null;
            var queryString = queryParams
                .filter(function (_a) {
                var k = _a[0], v = _a[1];
                return v != null;
            })
                .map(function (_a) {
                var k = _a[0], v = _a[1];
                return k + "=" + v;
            })
                .join('&');
            return queryString === '' ? baseUrl : baseUrl + "?" + queryString;
        },
        withQueryParams: function () {
            var params = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                params[_i] = arguments[_i];
            }
            return _routeCreator(pathParts, params.concat(queryParams));
        },
        parse: function (queryString) {
            return parse_1.parse(queryString);
        },
    };
}
